<template>
  <div
    ref="container"
    class="relative overflow-hidden whitespace-nowrap before:from-bg-static-info-max after:from-bg-static-info-max before:absolute before:inset-y-0 before:left-0 before:z-[1] before:w-6 before:bg-gradient-to-r before:to-transparent before:content-[''] after:absolute after:inset-y-0 after:right-0 after:w-6 after:bg-gradient-to-l after:to-transparent after:content-['']"
  >
    <!-- eslint-disable tailwindcss/no-custom-classname -->
    <p
      ref="text"
      class="inline-block px-4"
      :class="{ 'animate-scroll': hasOverflow }"
    >
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, useTemplateRef } from 'vue'

const text = useTemplateRef<HTMLElement>('text')
const container = useTemplateRef<HTMLElement>('container')

const hasOverflow = ref(false)

const checkOverflow = () => {
  if (!container.value || !text.value) return
  hasOverflow.value = text.value.scrollWidth > container.value.clientWidth
}

onMounted(() => {
  nextTick(() => checkOverflow())
})
</script>

<style>
@keyframes scroll {
  0%,
  20% {
    transform: translateX(0);
    margin-left: 0;
  }
  70%,
  80% {
    margin-left: 100%;
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
    margin-left: 0;
  }
}

.animate-scroll {
  animation: scroll 10s ease-in-out infinite;
  transform: translateX(0);
}
</style>
